var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsortium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.12591C9 6.39952 10.3995 5 12.1259 5C13.8523 5 15.2518 6.39952 15.2518 8.12591C15.2518 9.8523 13.8523 11.2518 12.1259 11.2518C10.3995 11.2518 9 9.8523 9 8.12591ZM12.1259 6.27772C11.1052 6.27772 10.2777 7.10518 10.2777 8.12591C10.2777 9.14663 11.1052 9.97409 12.1259 9.97409C13.1466 9.97409 13.9741 9.14663 13.9741 8.12591C13.9741 7.10518 13.1466 6.27772 12.1259 6.27772ZM14 16.1259C14 14.3995 15.3995 13 17.1259 13C18.8523 13 20.2518 14.3995 20.2518 16.1259C20.2518 17.8523 18.8523 19.2518 17.1259 19.2518C15.3995 19.2518 14 17.8523 14 16.1259ZM17.1259 14.2777C16.1052 14.2777 15.2777 15.1052 15.2777 16.1259C15.2777 17.1466 16.1052 17.9741 17.1259 17.9741C18.1466 17.9741 18.9741 17.1466 18.9741 16.1259C18.9741 15.1052 18.1466 14.2777 17.1259 14.2777ZM7.12591 13C5.39952 13 4 14.3995 4 16.1259C4 17.8523 5.39952 19.2518 7.12591 19.2518C8.8523 19.2518 10.2518 17.8523 10.2518 16.1259C10.2518 14.3995 8.8523 13 7.12591 13ZM5.27772 16.1259C5.27772 15.1052 6.10518 14.2777 7.12591 14.2777C8.14663 14.2777 8.97409 15.1052 8.97409 16.1259C8.97409 17.1466 8.14663 17.9741 7.12591 17.9741C6.10518 17.9741 5.27772 17.1466 5.27772 16.1259Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsortium);
export default __webpack_public_path__ + "static/media/Consortium.d737e61bdf8e8038378c5ddeec115dab.svg";
export { ForwardRef as ReactComponent };